// extracted by mini-css-extract-plugin
export default {"notificationsWrap":"Notifications_notificationsWrap__ZL8rD","notificationsList":"Notifications_notificationsList__xdRho"};